import React from "react";
import { useViewPitches } from "../../hooks/viewpitches/useViewPitches";
import ViewPitchesScreen from "../../components/viewpitches/ViewPitchesScreen";

/**
 * The club's entrance to View Pitches. The page itself is the shared
 * `ViewPitchesScreen`; the club is the only one of the three routes that also
 * gets the Free-Agents filter, which is the existing `free_agents_only=true`
 * query and now lives inside the filter panel instead of a lone toggle above
 * the list.
 */
const ViewPitches = () => {
  const vp = useViewPitches(false);

  if (!vp.tender) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#F5F7FB]">
        <p className="text-[14px] text-[#6B7280]">
          Request data not found. Redirecting...
        </p>
      </div>
    );
  }

  return <ViewPitchesScreen {...vp} showFreeAgentsFilter />;
};

export default ViewPitches;
